import React, { useState, useEffect } from 'react';
import { Collapse, Typography } from 'antd';
import { SelectionProcessesService } from '@frontend/src/core/services/selection_processes_service';
import { openNotificationWithIcon } from '@frontend/src/utilities/notificationWithIcon';
import { getAssessmentsBy } from '@frontend/src/core/services/assessment_service';
import { EducationService } from '../../../../src/core/services/education_service';
import { HiringAssessmentsPanel } from './HiringAssessmentsPanel';
import HiringForm from './HiringForm';
import FilterModal from './FilterModal';
import './FilterForm.module.scss';
const { Text } = Typography;

const MainFilter = ({
  lists = [],
  selection_process,
  hiring,
  readonly = false,
  mettlActive = false
}) => {
  const [rules, setRules] = useState({});
  const service = new SelectionProcessesService();
  const [hiringData, setHiring] = useState(hiring);
  const [assessments, setAssessments] = useState();
  const [rulesTest, setRulesTest] = useState({});
  const [universities, setUniversities] = useState([]);
  const educationService = new EducationService();
  const onHiringSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      service.updateHiring(
        selection_process.id,
        values,
        (data) => {
          setHiring(data.hiring);
          openNotificationWithIcon('success', 'Actualizado correctamente', '');
        },
        console.error
      );
    });
  };

  const handleSearchUniversities = (value, selected = "") => {
    educationService.getUniversities(
      { items: 20, search: value, selected: selected },
      (res) => {
        handleUniversities(res.data)
      },
      console.error
    )
  }

  useEffect(() => {
    service.fetchRuleElements(selection_process.id, setRules, console.error);
    getAssessmentsBy({ status: 'active', selection_process_id: selection_process.id }).then(({ data }) => {
      setAssessments(data);
    });
    educationService.getUniversities(
      { items: 20 }, 
      (res) => {handleUniversities(res.data)}, 
      console.error
    )
  }, []);

  useEffect(() => {
    if (mettlActive && rules) {
      service.fetchRuleTestElements((data) => {
        let external = false
        const options = data.map((item) => {
          if(item.external_test) external = true

          return ({
            id: item.test_id,
            label: item.name,
            value: item.test_id,
            childrensGroup: item.dimentions,
          })

        })
        const newData = {
          ...rules,
          Pruebas: {
            value: "tests",
            type: "group",
            options: options,
            externalTests: external
          }
        }
        setRulesTest(newData);
      }, console.error);
    }
  }, [rules]);

  const handleUniversities = (result) => {
    setUniversities(result.map((item) => {
      return {
        label: item.name,
        value: item.name
      }
    }))
  }

  return (
    <div className="main-form">
      <Collapse>
        {lists.length ? (
          <Collapse.Panel key="1" header="Filtros" forceRender>
            <Text>
              Desde aquí podrás establecer las reglas de avance entre una etapa
              y otra del tablero de candidatos.
            </Text>
            <div className="filter-item-list-container">
              {lists.map((value, index) => (
                <div key={index} className="filter-item-container">
                  {!mettlActive && Object.keys(rules) && <FilterModal
                    rules={rules}
                    value={value}
                    readonly={readonly}
                    hybridOptions={{
                      universities: universities,
                    }}
                    hybridSearch={{
                      universities: handleSearchUniversities
                    }}
                  />}
                  {mettlActive && Object.keys(rulesTest) && <FilterModal
                    rules={rulesTest}
                    value={value}
                    readonly={readonly}
                    hybridOptions={{
                      universities: universities,
                    }}
                    hybridSearch={{
                      universities: handleSearchUniversities
                    }}
                  />}
                </div>
              ))}
            </div>
          </Collapse.Panel>
        ) : null}
        <Collapse.Panel key="2" header="Datos de contratación" forceRender>
          <HiringForm
            onSubmit={onHiringSubmit}
            hiring={hiringData}
            readonly={readonly}
            selection_process={selection_process}
          />
        </Collapse.Panel>
        {assessments?.length && (
          <Collapse.Panel key={3} header="Evaluaciones" forceRender>
            <HiringAssessmentsPanel
              initialAssessments={assessments}
              selectionProcessId={selection_process.id}
              value={selection_process.assessment_id || undefined}
              readonly={readonly}
            />
          </Collapse.Panel>
        )}
      </Collapse>
    </div>
  );
};

export default MainFilter;
